"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoastalErosionEstimatedDistanceLost$ = exports.CoastalErosionEstimatedDistanceLost$outboundSchema = exports.CoastalErosionEstimatedDistanceLost$inboundSchema = void 0;
exports.coastalErosionEstimatedDistanceLostToJSON = coastalErosionEstimatedDistanceLostToJSON;
exports.coastalErosionEstimatedDistanceLostFromJSON = coastalErosionEstimatedDistanceLostFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const coastalerosionestimateddistancelostterm_js_1 = require("./coastalerosionestimateddistancelostterm.js");
/** @internal */
exports.CoastalErosionEstimatedDistanceLost$inboundSchema = z.object({
    long_term: z.nullable(coastalerosionestimateddistancelostterm_js_1.CoastalErosionEstimatedDistanceLostTerm$inboundSchema),
    medium_term: z.nullable(coastalerosionestimateddistancelostterm_js_1.CoastalErosionEstimatedDistanceLostTerm$inboundSchema),
    short_term: z.nullable(coastalerosionestimateddistancelostterm_js_1.CoastalErosionEstimatedDistanceLostTerm$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "long_term": "longTerm",
        "medium_term": "mediumTerm",
        "short_term": "shortTerm",
    });
});
/** @internal */
exports.CoastalErosionEstimatedDistanceLost$outboundSchema = z.object({
    longTerm: z.nullable(coastalerosionestimateddistancelostterm_js_1.CoastalErosionEstimatedDistanceLostTerm$outboundSchema),
    mediumTerm: z.nullable(coastalerosionestimateddistancelostterm_js_1.CoastalErosionEstimatedDistanceLostTerm$outboundSchema),
    shortTerm: z.nullable(coastalerosionestimateddistancelostterm_js_1.CoastalErosionEstimatedDistanceLostTerm$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        longTerm: "long_term",
        mediumTerm: "medium_term",
        shortTerm: "short_term",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CoastalErosionEstimatedDistanceLost$;
(function (CoastalErosionEstimatedDistanceLost$) {
    /** @deprecated use `CoastalErosionEstimatedDistanceLost$inboundSchema` instead. */
    CoastalErosionEstimatedDistanceLost$.inboundSchema = exports.CoastalErosionEstimatedDistanceLost$inboundSchema;
    /** @deprecated use `CoastalErosionEstimatedDistanceLost$outboundSchema` instead. */
    CoastalErosionEstimatedDistanceLost$.outboundSchema = exports.CoastalErosionEstimatedDistanceLost$outboundSchema;
})(CoastalErosionEstimatedDistanceLost$ || (exports.CoastalErosionEstimatedDistanceLost$ = CoastalErosionEstimatedDistanceLost$ = {}));
function coastalErosionEstimatedDistanceLostToJSON(coastalErosionEstimatedDistanceLost) {
    return JSON.stringify(exports.CoastalErosionEstimatedDistanceLost$outboundSchema.parse(coastalErosionEstimatedDistanceLost));
}
function coastalErosionEstimatedDistanceLostFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CoastalErosionEstimatedDistanceLost$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CoastalErosionEstimatedDistanceLost' from JSON`);
}
//# sourceMappingURL=coastalerosionestimateddistancelost.js.map